import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsRunNormalLarge = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#sports_run_normal_large_svg__clip0_138_71)" fill="">
        <path d="M15.99 34.98l-1.97-2H11.2l1.98 2h2.81zm-8.75-6l1.98 2h2.82l-1.98-2H7.24z" />
        <path d="M44.49 35.32l-2.3-1.22-12.24-22.67a5.008 5.008 0 00-4.43-2.65h-.01a4.991 4.991 0 00-4.49 2.78l-1.15 2.37A3.478 3.478 0 0117 10.51V4.33A3.39 3.39 0 0013.62.94a3.093 3.093 0 00-2.72 1.63L4.02 15.48l-1.36.53a4.21 4.21 0 00-1.46 6.86l4.06 4.11h2.83l-5.46-5.52a2.139 2.139 0 01-.58-2 2.195 2.195 0 011.35-1.59l1.03-.4 17.74 17.51h2.85L5.93 16.14l6.74-12.63a1.08 1.08 0 01.95-.57A1.391 1.391 0 0115 4.33v6.18a5.484 5.484 0 005.47 5.47h.63l1.72-3.53a3.023 3.023 0 015.37-.07l3.08 5.72-5.3 2.81v2.27l6.25-3.33 1.53 2.82-5.82 3.1v2.26l6.77-3.59 1.53 2.83L30 30.58v2.26l7.17-3.81 3.54 6.55 2.84 1.51a4.622 4.622 0 011.88 6.25 3.069 3.069 0 01-2.74 1.67h-7.76a21.724 21.724 0 01-15.38-6.43l-1.58-1.6h-2.82l2.98 3.01a23.776 23.776 0 0016.8 7.02h7.76a5.11 5.11 0 004.56-2.82 6.624 6.624 0 00-2.76-8.87z" />
      </g>
      <defs>
        <clipPath id="sports_run_normal_large_svg__clip0_138_71">
          <path fill="#fff" d="M0 0h48v48H0z" />
        </clipPath>
      </defs>
    </svg>
  )
);
SvgSportsRunNormalLarge.defaultProps = {
  color: 'currentColor',
  size: 48,
  title: undefined,
  titleId: undefined
};
SvgSportsRunNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsRunNormalLarge;
